import { useState } from 'react'

import { Cell } from '../../../../components/ReusableComponents/Table'
import DateTooltip from './DateTooltip'
import styles from './HotelNameCell.module.scss'

const HotelNameCell = ({
  brand,
  name,
  groupName,
  navigationControl,
  paymentMethod,
  paymentPeriod,
  packagePlans,
  packageFee,
  discount,
  monthlyFeeAfterDiscount,
  subsidiaryId,
  serviceStartDate,
  actualServiceStartDate,
  addedOn,
  serviceBlockOn,
  emailLastSentOn,
  className,
  ...props
}) => {
  const [isHovering, setHovering] = useState(false)

  return (
    <Cell
      className={[
        navigationControl ? styles.hotelNameCellWithNavigation : styles.hotelNameCell,
        className
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    >
      <div className={styles.wrapper}>
        <div className={styles.hotelBrand}>{brand}</div>
        <div
          className={styles.hotelShortName}
          title={name ? String(name) : undefined}
          onMouseOver={() => setHovering(true)}
          onMouseLeave={() => setHovering(false)}
        >
          {name}
          <DateTooltip
            paymentMethod={paymentMethod}
            paymentPeriod={paymentPeriod}
            packagePlans={packagePlans}
            packageFee={packageFee}
            discount={discount}
            monthlyFeeAfterDiscount={monthlyFeeAfterDiscount}
            serviceStartDate={serviceStartDate || actualServiceStartDate}
            addedOn={addedOn}
            serviceBlockOn={serviceBlockOn}
            emailLastSentOn={emailLastSentOn}
            isVisible={isHovering}
          />
        </div>
        {navigationControl && (
          <div className={styles.navigationControl}>{navigationControl}</div>
        )}
        {groupName && <div className={styles.tooltip}>{groupName}</div>}
      </div>
    </Cell>
  )
}

export default HotelNameCell
